import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable, switchMap, tap } from 'rxjs';

import { UserContext } from '../services/context/user.context.service';
import { CustomerCareService } from '../services/cx/customer-care.service';
import { AuthService } from '@auth0/auth0-angular';
import { AmplitudeService } from '../services/amplitude.service';

@Injectable({
  providedIn: 'root',
})
export class UserContextGuard implements CanActivate {
  constructor(
    private readonly _selfSvc: CustomerCareService,
    private readonly _authSvc: AuthService,
    private readonly _amplitudeSvc: AmplitudeService,
    private readonly _userCtxSvc: UserContext
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this._selfSvc.loadUserContext().pipe(
      tap(_ => {
        this._authSvc.user$
          .pipe(
            switchMap(user => {
              this._amplitudeSvc.setUserId(user?.email);

              return this._selfSvc.getUserSettingsByPbEmail(user?.email || '');
            })
          )
          .subscribe(configs => {
            this._userCtxSvc.setConfigurations(configs);
          });
      })
    );
  }
}
